import { render } from "./SimpleValidateCarousel.vue?vue&type=template&id=10ae93f8&scoped=true"
import script from "./SimpleValidateCarousel.vue?vue&type=script&lang=js"
export * from "./SimpleValidateCarousel.vue?vue&type=script&lang=js"

import "./SimpleValidateCarousel.vue?vue&type=style&index=0&id=10ae93f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ae93f8"]])

export default __exports__